import { customElement } from 'lit/decorators.js';
import { WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTIMALWARE_SCAN_TASKS_EXCLUSIONS_GRID } from '../../../../../../../../../../webcomponents.constants';
import { GzPolicyUiSettingsGridWebComponent } from '../../../../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/gridView';
import { Column, ColumnKeys, getGridColumnDetails, GRID_COLUMNS } from './grid-config';
import { GzExchangeAntimalwareScanTaskExclusionsGridDataProvider } from './GzExchangeAntimalwareScanTaskExclusionsGridDataProvider';
import { html, TemplateResult } from 'lit';
import { ValidationResult } from '../../../../../../../../../../ui/gzForm/formField/types/form-validator';
import { validateDuplicates, validateScopeByType } from './utils/validators';
import { GRID_ITEM_FORM_ID } from '../../../../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/base/component/GzPolicyUiSettingsBaseGrid';
import { RequiredValidator } from '../../../../../../../../../../ui/gzForm/validators/required.validator';
import { GridCellEditWebComponent } from '../../../../../../../../../../grid/uiElements/gridCellEdit';
import {
  ExchangeAntimalwareScanTaskTargetExclusion,
  ExchangeAntimalwareScanTaskTargetExclusionType,
} from '@nirvana/shared/dtos/types/policies/common';
import { CustomizableValidator } from '../../../../../../../../../../ui/gzForm/validators/customizable.validator';
import { translateFn } from '../../../../../../../../../../utils/translator.helper';

@customElement(WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTIMALWARE_SCAN_TASKS_EXCLUSIONS_GRID)
export class GzExchangeAntimalwareScanTaskExclusionsGridWebComponent extends GzPolicyUiSettingsGridWebComponent<
  Column,
  ColumnKeys,
  ExchangeAntimalwareScanTaskTargetExclusion,
  ExchangeAntimalwareScanTaskTargetExclusion,
  GzExchangeAntimalwareScanTaskExclusionsGridDataProvider
> {
  protected allColumnDetails = getGridColumnDetails();
  protected columns = GRID_COLUMNS;
  protected translations = {
    editRow: translateFn('Edit exclusion'),
    deleteRow: translateFn('Delete'),
    emptyState: translateFn('No exclusions defined'),
  };

  protected getDataProvider(): GzExchangeAntimalwareScanTaskExclusionsGridDataProvider {
    return new GzExchangeAntimalwareScanTaskExclusionsGridDataProvider(this.initialGridItems);
  }

  protected renderGridItemForm(): TemplateResult {
    return html` <gz-policy-panel-exchange-antimalware-scan-tasks-exclusions-item
      id="${GRID_ITEM_FORM_ID}"
    ></gz-policy-panel-exchange-antimalware-scan-tasks-exclusions-item>`;
  }

  protected validateGridItemBeforeAdd(gridItemFormValue: ExchangeAntimalwareScanTaskTargetExclusion): ValidationResult {
    // check for duplicates
    return validateDuplicates(
      gridItemFormValue,
      (this.gridComponent.dataProvider as GzExchangeAntimalwareScanTaskExclusionsGridDataProvider).items
    );
  }

  protected onEditRowEnabled(event: CustomEvent) {
    // set validators on edited row
    const { rowData } = event.detail;

    this.gridComponent.controller?.setValidatorsOnRowAndColumn(rowData.index, ColumnKeys.SCOPE, [
      RequiredValidator(translateFn('Required field')),
      CustomizableValidator(value =>
        validateScopeByType(rowData.item.type as ExchangeAntimalwareScanTaskTargetExclusionType, value)
      ),
    ]);
  }

  protected isEditedRowChanged(
    oldItem: ExchangeAntimalwareScanTaskTargetExclusion,
    newItem: ExchangeAntimalwareScanTaskTargetExclusion
  ): boolean {
    return oldItem.scope !== newItem.scope;
  }

  protected validateGridItemBeforeEdit(
    oldItem: ExchangeAntimalwareScanTaskTargetExclusion,
    newItem: ExchangeAntimalwareScanTaskTargetExclusion
  ): ValidationResult {
    // skip if entity is not changed
    if (newItem.scope === oldItem.scope) {
      return { valid: true };
    }

    return this.validateGridItemBeforeAdd(newItem);
  }

  protected revertGridCellEditValue(
    gridCellEdit: GridCellEditWebComponent,
    oldItem: ExchangeAntimalwareScanTaskTargetExclusion
  ): void {
    if (gridCellEdit.id === ColumnKeys.SCOPE) {
      gridCellEdit.value = oldItem.scope;
    }
  }
}
